<script lang='ts'>
    import {round, type XSSDetails} from '../../Util/utils';
    import ProgramAchievabilityStatusIcon from "./ProgramAchievabilityStatusIcon.svelte";
    import ProgramTargetChangeValue from "./ProgramTargetChangeValue.svelte";
    import type {TargetAchievability} from "../modules/ProgramAchievability"
    import { Skeleton } from '@/Common';

    export let currentSignature: XSSDetails
    export let targetSignature: XSSDetails
    export let targetAchievability: TargetAchievability
    export let description: string = ""
    export let estimatedRowName = "Estimated"
    export let disabled = false
    
</script>


<div class="flex flex-col gap-6 text-left">
    <div class="text-base font-bold text-left flex flex-col">
        <span class="leading-none">Fitness Signature</span>
        <span class="text-slate-600 font-normal text-sm"> {description}</span>
    </div>
    {#if currentSignature && targetSignature && !disabled}
    <div class="grid items-baseline gap-2 md:gap-3">
        <span class="row-start-1 col-start-2 text-sm text-slate-500">Threshold<br/>Power (w)</span>
        <span class="col-start-3 text-sm text-slate-500">High Intensity<br/>Energy (kJ)</span>
        <span class="col-start-4 text-sm text-slate-500">Peak<br/>Power (w)</span>
        <span class="row-start-2 text-sm text-left text-slate-600">Current</span>
        <span class="text-[--color-xlss]">{Math.round(currentSignature.xlss)}</span>
        <span class="text-[--color-xhss]">{round(currentSignature.xhss / 1000, 1)}</span>
        <span class="text-[--color-xpss]">{Math.round(currentSignature.xpss)}</span>
        <span class="row-start-3 text-sm text-left text-slate-600">{estimatedRowName}</span>
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="text-[--color-xlss]">{Math.round(targetSignature.xlss)}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={Math.round(targetSignature.xlss) - Math.round(currentSignature.xlss)} />
                <ProgramAchievabilityStatusIcon status={targetAchievability.low}/>
            </div>
        </span>
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="text-[--color-xhss]">{round(targetSignature.xhss / 1000, 1)}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={round(targetSignature.xhss/1000, 1) - round(currentSignature.xhss/1000, 1)} />
                <ProgramAchievabilityStatusIcon status={targetAchievability.high}/>
            </div>
        </span>
        <span class="inline-flex items-baseline gap-2 flex-wrap">
            <span class="text-[--color-xpss]">{Math.round(targetSignature.xpss)}</span>
            <div class="inline-flex gap-1 border rounded-full border-black/10 px-1 items-baseline text-sm">
                <ProgramTargetChangeValue value={Math.round(targetSignature.xpss) - Math.round(currentSignature.xpss)} />
                <ProgramAchievabilityStatusIcon status={targetAchievability.peak}/>
            </div>
        </span>
    </div>
    {:else}
    <div class="flex flex-col gap-3">
        <Skeleton class="ml-auto w-9/12 h-6"/>
        <Skeleton class= "h-20"/>
    </div>
    {/if}
</div>

    